import styles from "./ChartHeader.module.scss"

const ChartHeader = ({ label, value, Icon, color }) => {
  return (
    <div className="d-flex align-items-center justify-content-between">
      <div>
        <div className={styles["label"]}>{label}</div>
        <div className={styles["value"]}>{value}</div>
      </div>
      <div>
        <Icon size={24} color={color} />
      </div>
    </div>
  )
}

export default ChartHeader
